import { env } from './config.js'

const GOOGLE_PROPERTY_ALLOWLIST = {
  onboarding_abandoned: ['step', 'question'],
  language_selected: ['language'],
  onboarding_started: [],
  question_viewed: ['question'],
  answer_selected: ['question', 'multi'],
  back_clicked: ['step', 'question'],
  contact_form_viewed: [],
  generate_lead: ['course', 'direction', 'level'],
  recommendation_shown: ['course', 'direction', 'level'],
  lead_submission_failed: ['reason'],
  journey_restarted: [],
  advisor_contact_clicked: ['course'],
  course_detail_clicked: ['course'],
}

function googleProperties(event, properties) {
  const allowed = GOOGLE_PROPERTY_ALLOWLIST[event]
  if (!allowed) return null
  return Object.fromEntries(allowed
    .filter((key) => ['string', 'number', 'boolean'].includes(typeof properties[key]))
    .map((key) => [key, properties[key]]))
}

export function initializeAnalytics() {
  if (typeof window === 'undefined' || !/^G-[A-Z0-9]+$/.test(env.analyticsId)) return
  window.dataLayer = window.dataLayer || []
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments) }
  window.gtag('js', new Date())
  window.gtag('config', env.analyticsId, {
    cookie_domain: 'auto',
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  })

  if (!document.querySelector(`script[data-ua-ga="${env.analyticsId}"]`)) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(env.analyticsId)}`
    script.dataset.uaGa = env.analyticsId
    document.head.append(script)
  }
}

export function track(event, properties = {}) {
  const payload = { event, properties, analyticsId: env.analyticsId || undefined, timestamp: new Date().toISOString() }
  window.dispatchEvent(new CustomEvent('ua:analytics', { detail: payload }))
  const gaProperties = googleProperties(event, properties)
  if (gaProperties && typeof window.gtag === 'function') {
    window.gtag('event', event, { ...gaProperties, send_to: env.analyticsId })
  }
  if (!env.analyticsEndpoint) return
  const body = JSON.stringify(payload)
  if (navigator.sendBeacon) navigator.sendBeacon(env.analyticsEndpoint, new Blob([body], { type: 'application/json' }))
  else fetch(env.analyticsEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body, keepalive: true }).catch(() => {})
}

export const __test = { googleProperties }
